import { render, staticRenderFns } from "./PricingTabs.vue?vue&type=template&id=d89a2b10&scoped=true"
import script from "./PricingTabs.vue?vue&type=script&lang=js"
export * from "./PricingTabs.vue?vue&type=script&lang=js"
import style0 from "./PricingTabs.vue?vue&type=style&index=0&id=d89a2b10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a2b10",
  null
  
)

export default component.exports